import { createSelector } from 'reselect';

import * as types from '../actions/actionTypes';

/**
 * Reducer to keep the currently selected fabric in state.
 *
 * @param state
 * @param action
 * @returns {*}
 */
export default (state, action) => {
    switch (action.type) {
        case types.FABRIC_SELECTED:
            return Object.assign({}, state, { fabricId: action.fabricId });

        default:
            return state;
    }
};

/**
 * Reducer for changing the language specific fabric data.
 *
 * @param state
 * @param action
 * @param languages
 * @returns {*}
 */
export const fabrics = (state, action, languages) => {
    switch (action.type) {
        case types.LOCALE_CHANGED:
            return Object.assign({}, languages[action.currentLanguage].fabrics);

        case types.LOCALE_SETTED_FROM_URI:
            return Object.assign({}, languages[action.language].fabrics);

        default:
            return state;
    }
};

export const getFabrics = state => state.stolo.i18n.fabrics;
export const getActiveFabricId = state => state.stolo.fabric.fabricId;
export const getFabricPayload = state => (state.location.payload || {}).fabricId || null;

export const getActiveFabric = createSelector(
    [getActiveFabricId, getFabrics],
    (fabricId, fabrics) => fabrics[fabricId],
);

export const getActiveFabricTitle = createSelector(
    [getActiveFabric],
    fabric => fabric.title,
);

export const getActiveFabricProcessingTime = createSelector(
    [getActiveFabric],
    fabric => fabric.specification.processingTime,
);

export const getActiveFabricMaterial = createSelector(
    [getActiveFabric],
    fabric => fabric.specification.material,
);

export const getActiveFabricSelectedValues = createSelector(
    [getActiveFabric],
    fabric => fabric.selectedValues,
);

export const getFabricIdFromURI = createSelector(
    [getFabricPayload],
    uri => {
        if (!uri) {
            return null;
        }
        const mapUriToId = {
            baumwollstoff: 1175,
            viskosejersey: 1176,
            baumwolljersey: 1178,
            polyesterjersey: 1236,
        };
        return mapUriToId.uri || null;
    },
);



// WEBPACK FOOTER //
// ./src/reducers/fabrics.js